import Calendar from 'components/Calendar/styled';

export default Calendar;
